<template>
    <ns-modal :title="txc.edit_comm_preferences" v-model="dialog" :fullscreen="fullScreen" @input="closeDialog">
        <server-error v-if="!!dialogError" :error="dialogError"/>
        <p class="pb-4">{{txc.email_sms_desc}}</p>
        <v-checkbox :disabled="!email" @change="setchangeFlag()" v-model="emailActivated">
            <template v-slot:label>
                <div>{{txc.email_opt_in}}</div>
            </template>
        </v-checkbox>

        <div v-if="marketLoggedIn != 'JP'">
            <v-checkbox :disabled="!mobileNumber" @change="setchangeFlag()" v-model="smsActivated" hide-details="true">
                <template v-slot:label>
                    <div>{{txc.sms_opt_in}}</div>
                </template>
            </v-checkbox>
            <div class="inset mb-3" v-show="smsActivated">
                <span class="sms-terms" v-html="translationsTerms.terms_text"></span>
                <hr/>
                <p>{{txc.sms_messages_sent_to}}</p>
                <div class="field-value">{{mobileNumber}}</div>
            </div>
        </div>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        :disabled="!commPrefChanged"
                        @click="updateMarketingPref"
                    >{{sharedStrings.generic.save}}
                    </button>
                </v-flex>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="secondary-hit fluid"
                        @click="closeDialog">
                        {{sharedStrings.generic.cancel}}
                    </button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import * as ruleSet from '../../repositories/globalRules.js';
import {ProfileService} from '@nuskin/ns-account';
import { mapGetters,mapActions} from 'vuex'

import { NsModal } from '@nuskin/design-components';
import ServerError from '../ServerError';
import profileUtils from '../../repositories/profileUtils';

export default {

    components: {
        NsModal,
        ServerError
    },
    data() {
        return {
            ruleSet,
            dialog: true,
            dialogError: null,
            smsActivated: '',
            emailActivated: '',
            commPrefChanged: false
        }
    },
    computed: {
        ...mapGetters({
            marketLoggedIn: 'marketLoggedIn',
            txc: 'translationsCommunication',
            email: 'email',
            fullScreen: 'mobileView',
            mobileNumber:'mobileFormatted',
            acceptMarketingSMS:'acceptMarketingSMS',
            acceptMarketingEmail:'acceptMarketingEmail',
            sharedStrings: 'sharedStrings',
            translationsTerms: 'translationsTerms'
        })
    },
    methods: {
        ...mapActions(['setAccount']),
        closeDialog() {
            this.$emit('closeDialog');
            this.dialogError = null;
        },
        updateMarketingPref() {
            let pref = {
                'preferences': {
                    'acceptMarketingEmail': this.emailActivated,
                    'acceptMarketingSMS': this.smsActivated
                }
            };
            ProfileService.updateAccountInfo(pref).then((response) => {
                if (response && response.data && response.data.account) {
                    this.setAccount(response.data.account);
                    this.closeDialog();
                    profileUtils.publishAnalytics(this.$analytics.category.communications, 'communication_preferences_update', pref);
                }
            }).catch(error => {
                this.dialogError = error;
            });
        },
        setchangeFlag() {
            this.commPrefChanged = this.smsActivated !== this.acceptMarketingSMS || this.emailActivated !== this.acceptMarketingEmail;
        }
    },
    created() {
        this.smsActivated = this.acceptMarketingSMS;
        this.emailActivated = this.acceptMarketingEmail;
        profileUtils.publishAnalytics(this.$analytics.category.communications, 'communication_preferences_dialog', 'opened');
    },
    destroyed() {
        profileUtils.publishAnalytics(this.$analytics.category.communications, 'communication_preferences_dialog', 'closed');
    }
}
</script>

<style lang="scss">
    .sms-terms a { 
        text-transform: capitalize !important;
    }
</style>
